import FormattedMessage from 'I18n/components/FormattedMessage';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import Small from 'UIComponents/elements/Small';
import { useStrategy } from '../../hooks/useStrategy';
import { useContext } from 'react';
import { matchDataByStatus } from '../../utils/matchDataByStatus';
import MatchStatusIcon from './MatchStatusIcon';
import { PASS } from 'customer-data-filters-ui/filterQueryFormat/MatchStatus';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ViewerConditionsGroupMatchStatusTag = props => {
  const {
    matchStatus,
    hideIcon
  } = props;
  const {
    props: {
      baseFilterFamily
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    getFilterFamilyObjectName,
    isTestFiltersEnabled
  } = useStrategy();
  if (!matchStatus) {
    return null;
  }
  const matchData = matchDataByStatus[matchStatus];
  if (!matchData) {
    return null;
  }
  const message = matchStatus === PASS ? 'newCustomerDataFilters.viewerLogicGroupStatusTag.pass' : 'newCustomerDataFilters.viewerLogicGroupStatusTag.fail';
  const objectName = getFilterFamilyObjectName(baseFilterFamily);
  if (!isTestFiltersEnabled) {
    return /*#__PURE__*/_jsxs(View, {
      marginInlineEnd: "200",
      marginBlockEnd: "100",
      children: [/*#__PURE__*/_jsx(matchData.IconComponent, {
        color: matchData.iconColor
      }), /*#__PURE__*/_jsx(Small, {
        use: "help",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: message,
          options: {
            objectName
          }
        })
      })]
    });
  }
  if (hideIcon) {
    return /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "200",
      as: "div",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: message,
        options: {
          objectName
        }
      })
    });
  }
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    justifyContent: "space-between",
    marginBlockEnd: "200",
    paddingInlineEnd: "200",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: message,
      options: {
        objectName
      }
    }), /*#__PURE__*/_jsx(MatchStatusIcon, {
      matchStatus: matchStatus
    })]
  });
};
export default ViewerConditionsGroupMatchStatusTag;